import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import AppLayout from './components/AppLayout';
import HomePage from './pages/HomePage';
import UniversityPage from './pages/UniversityPage';
import DepartmentPage from './pages/DepartmentPage';
import ProfessorPage from './pages/ProfessorPage';
import AboutPage from './pages/AboutPage';
import AddProfessorPage from './pages/AddProfessorPage';
import ProfilePage from './pages/ProfilePage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import NotFoundPage from './pages/NotFoundPage';
import MarketingPosterPage from './pages/MarketingPosterPage';

function App() {

  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <AppLayout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/add-lecturer" element={<AddProfessorPage />} />
              <Route path="/add-professor" element={<AddProfessorPage />} />
              <Route path="/university/:universityId" element={<UniversityPage />} />
              <Route path="/university/:universityId/department/:departmentId" element={<DepartmentPage />} />
              <Route path="/lecturer/:professorId" element={<ProfessorPage />} />
              <Route path="/professor/:professorId" element={<ProfessorPage />} />
              <Route path="/poster" element={<MarketingPosterPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AppLayout>
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
